import { useEffect, useRef } from 'react';
import { useAuthStore } from '../stores/authStore';
import { AuthService } from '../services/authService';

export const useAuth = () => {
  const { user, isAuthenticated, isLoading, setUser, logout, setLoading, error, setError } = useAuthStore();
  const hasInitialized = useRef(false);

  useEffect(() => {
    const initializeAuth = async () => {
      // Prevent multiple initialization attempts
      if (hasInitialized.current) {
        return;
      }

      try {
        hasInitialized.current = true;
        setLoading(true);
        setError(null);
        const userProfile = await AuthService.getProfile();
        setUser(userProfile);
      } catch (error) {
        if (
          error instanceof Error &&
          (error.message.includes('Adult not found') || error.message.includes('No user found'))
        ) {
          setError('Your account is not yet set up. Please contact the administrator for access.');
        } else {
          setError('Session expired. Please login again.');
        }

        logout();
      } finally {
        setLoading(false);
      }
    };

    if (!hasInitialized.current && !user && !error) {
      initializeAuth();
    }
  }, []); // Remove dependencies to prevent re-runs

  const handleLogin = () => {
    AuthService.login();
  };

  const handleLogout = () => {
    AuthService.logout();
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login: handleLogin,
    logout: handleLogout,
  };
};
